import { createRouter, createWebHashHistory } from "vue-router";
import { nextTick } from "vue";
import Home from "../pages/Home.vue";
import NewsDetail from "../pages/NewsDetail.vue";
import About from "../pages/About.vue";
import Teacher from "../pages/Teacher.vue";
import LearningPath from "../pages/LearningPath.vue";
export default createRouter({
  history: createWebHashHistory(),
  scrollBehavior: async (to) => {
    if (to.hash) {
      await nextTick();
      await new Promise((resolve) => window.setTimeout(resolve, 80));
      const target = document.querySelector(to.hash);
      return target ? { el: to.hash, behavior: "smooth" } : { top: 0 };
    }
    return { top: 0 };
  },
  routes: [
    { path: "/", name: "home", component: Home },
    { path: "/about", name: "about", component: About },
    { path: "/teachers", name: "teachers", component: Teacher },
    {
      path: "/learning-path",
      name: "learning-path",
      component: LearningPath,
    },
    {
      path: "/news/:slug",
      name: "news-detail",
      component: NewsDetail,
      props: true,
    },
  ],
});
